import BasicInfoForm from './components/BasicInfoForm';
import Permissions from './components/Permissions';
import PersonalInformation from './components/PersonalInformation';
import SubjectAreaForm from './components/SubjectAreaForm';
import TechnologyForm from './components/TechnologyForm';
import UploadForm from './components/UploadForm';
import { LessonForm, SubjectArea } from './types';

export const STEPS = [
  {
    label: 'Basic Information',
    Component: BasicInfoForm,
  },
  {
    label: 'Technology',
    Component: TechnologyForm,
  },
  {
    label: 'Subject Areas',
    Component: SubjectAreaForm,
  },
  {
    label: 'Upload',
    Component: UploadForm,
  },
  {
    label: 'Personal Information',
    Component: PersonalInformation,
  },
  {
    label: 'Permissions',
    Component: Permissions,
  },
];

export const NUMBER_OF_STEPS = STEPS.length;

export const EMPTY_SUBJECT_FORM: Readonly<SubjectArea> = {
  subject: '',
  contentStrands: [],
  mnStandards: '',
};

export const EMPTY_FORM: LessonForm = {
  basicInfo: {
    lesson: {
      title: '',
      description: '',
    },
    gradeLevels: [],
    cstaStandards: '',
  },
  techRequirements: {
    technologies: [],
    categories: [],
    platforms: [],
  },
  subjectAreas: [{ ...EMPTY_SUBJECT_FORM }],
  upload: '',
  personalInformation: {
    name: '',
    email: '',
    twitter: '',
    school: {
      name: '',
      district: '',
      zip: undefined,
      state: '',
    },
    displayInfo: false,
  },
  permissions: {
    allResourcesLicensed: false,
    permissionGranted: false,
  },
};
